export const TREATMENT_CATEGORY_REQUEST_FOR_INFO = 'request_for_info';
export const TREATMENT_CATEGORY_PZR = 'pzr';
